import React from "react";
import { Author } from "../helper/interfaces";
import { getAuthorName } from "../helper/author";
import Link from "next/link";
import { getLinkObjectFromTeaser } from "../helper/link";

interface AuthorProfilesNNProps {
  authors: Author[];
  navigate?: (id?: string, ressortId?: string) => void;
}

function renderAuthor(author: Author, navigate?: (id?: string, ressortId?: string) => void) {
  const linkObject = getLinkObjectFromTeaser(author);
  if(linkObject && linkObject.articleId ) {
    return <Link href={`/article/${linkObject.articleId}`} className="article-author-name-linked" onClick={() => navigate && navigate(linkObject.articleId, linkObject.ressortId)}>{getAuthorName(author)}</Link>;
  }
  else if(linkObject && linkObject.ressortId) {
    return <Link href={`/ressort/${linkObject.ressortId}`} className="article-author-name-linked" onClick={() => navigate && navigate(linkObject.articleId, linkObject.ressortId)}>{getAuthorName(author)}</Link>;
  }
  return getAuthorName(author);
}

export default function AuthorProfilesNN({ authors, navigate }: AuthorProfilesNNProps) {
  return (
    <div className="article-authors-name article-authors-name--single">
      von{" "}
      {authors.map((element, index) => {
        return (
          <React.Fragment key={`author-${element.id}-${index}`}>
            {index > 0 && ", "}
            {renderAuthor(element, navigate)}
          </React.Fragment>
        );
      })}
    </div>
  );
}